import type { ClaimType, Benefit } from 'all-in-one-shared-api';

export const getClaimType = (claimType: ClaimType, benefit: Benefit): ClaimType | Benefit => {
  if (claimType.code === 'HOSP' || claimType.code === 'DEN' || claimType.code === 'MAT') {
    return claimType;
  }

  return benefit;
};
